<template>
    <b-modal id="orgPlaceSearch" :title="title" size="md" @show="fn_search">
        <div class="table_list">
            <ul class="search_filter">
                <li>
                    <p>{{ searchName }}</p>
                    <input type="text" :placeholder="`${searchName}을(를) 입력하세요`" class="form_control" v-model="orgPlceNm" @keyup.enter="fn_search">
                    <button class="btn btn_md btn_outline" @click="fn_search">조회</button>
                </li>
            </ul>
            <div class="modal_table">
                <table class="list">
                    <colgroup>
                        <col width="50">
                        <col width="50">
                    </colgroup>
                    <thead>
                        <tr>
                            <th></th>
                            <th>No</th>
                            <th>원산지코드</th>
                            <th>원산지명</th>
                        </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item, index) in orgPlaceList" :key="index">
                        <td>
                            <div class="form_checkbox">
                                <input type="checkbox" :id="'checkbox'+index" name="checkbox" v-model="checkBox" :value="index" @change="fn_check">
                                <label :for="'checkbox'+index"></label>
                            </div>
                        </td>
                        <td><span>{{ index + 1 }}</span></td>
                        <td><span>{{ item.org_plce_cd }}</span></td>
                        <td><span>{{ item.org_plce_nm }}</span></td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <template #modal-footer="{ ok }">        
            <b-button class="btn btn_md btn_gray" v-show="oneBtn" @click="fn_apply">{{ btnLeft }}</b-button>
            <b-button class="btn btn_md btn_deepblue" @click="fn_init(),ok()">{{ btnRight }}</b-button>
        </template>
    </b-modal>

</template>

<script>
    import axios from 'axios'

    export default {
        name: 'orgPlaceSearch',
        props: {
            title: String,
            btnLeft: String,
            btnRight: String,
            searchName: String,
            searchData: String,
            oneBtn: Boolean,
            filter: Boolean,
        },
        data() {
            return {
                checkBox : [],
                orgPlaceList : [],
                orgPlceNm : this.searchData
            }
        },
        watch : {
		    searchData(newValue) {
                console.log("변경 체크");
                //props 변경 여부 확인
                this.orgPlceNm = newValue;

            }
        },
        methods : {
            fn_search(){

                console.log("@@@@ this.searchData : %o",this.searchData);

                let param = new Object();
                param.orgPlceNm = this.orgPlceNm;


                console.log("@@@@ param : %o",param);

                axios
                    .post("/api/system/getOrgPlaceCode", param)
                    .then((res) => {
                        console.log("@@@@ dtl res : %o",res);
                        this.orgPlaceList = res.data.orgPlaceInfo;
                    })
                    .catch((err) => console.log(err));
                
            },
            fn_apply(){
                               
                if(this.checkBox.length == 0){
                    alert("체크된 약재가 없습니다.");
                }else if(this.checkBox.length > 1){
                    alert("한개 이상 선택할수 없습니다.");
                }else{                    
                    
                    let orgPlaceObject = this.orgPlaceList[this.checkBox[0]];
                    
                    //let medCode = this.medicineList[this.checkBox[0]].med_hrb_cd;
                    //let medName = this.medicineList[this.checkBox[0]].med_hrb_nm;
                    //let medHrbDtlSeq = this.medicineList[this.checkBox[0]].med_hrb_dtl_seq;
                    //let orgPlceNm = this.medicineList[this.checkBox[0]].org_plce_nm;


                    this.$emit('callback', orgPlaceObject);

                    this.fn_init();
                    this.$bvModal.hide('orgPlaceSearch');
                }                                        
            },
            fn_init(){
                this.orgPlaceList = [];
                this.checkBox = [];
                this.orgPlceNm = '';
            },
            fn_check(){
                if(this.checkBox.length > 1){
                    this.checkBox.splice(0,1);
                }
            }
        }
    }
</script>
